import { Record } from 'immutable';
import Hydrator from 'utils/Hydrator';

const CaseRecord = Record({
  businessId: null,
  caseState: null,
  caseStateName: null,
  details: null,
  followers: null,
  id: null,
  owner: null,
  private: null,
  product: null,
  productName: null,
  productNames: null,
  products: null,
  state: null,
  stateName: null,
  stateType: null,
  stateUpdatedAt: null,
  type: null,
  closed: null,
});

export default class Case extends CaseRecord {
  static deserialize(jsonObject = {}) {
    if (typeof jsonObject === 'undefined' || jsonObject === null) {
      return undefined;
    }

    const mapProperties = {
      stateUpdatedAt: Hydrator.timestamp2Date,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new Case(hydrated);
  }
}
